import { gql } from "@apollo/client";

const USER_BY_ID = gql`
  query getUserById($publicId: String, $showEntries: Boolean) {
    user(query: { publicId: $publicId }, showEntries: $showEntries) {
      email
      platforms {
        id
        title
        lightLogo
      }
      accessToken
      id
      entries
      paidAmount
      name
      surname
      middle_name
      name_passport
      middle_name_passport
      surname_passport
      role
      user_sports {
        club {
          id

          clubName
        }
        platformCoach {
          id
          user {
            name
            surname
            avatar
          }
        }
        id
        team
        sport {
          id
          title
          icon
        }
      }
      gender
      dob
      nation
      avatar
      phone
      street
      city
      facebook
      instagram
      website
      gtw_points
      preferred_language

      user_coach {
        id
        user {
          id
        }
        coaches {
          id
          user {
            id
            email
          }
        }
      }
      user_parents {
        id
        parent {
          id
          name
          email
          avatar
          surname
        }
      }
      user_club_id {
        id
        clubName
      }
      friends {
        id
        name
        email
        avatar
        surname
      }
      coach_access
      club_access
      parent_access
      createdAt
      linkedIn
      youtube
      tiktok
      citizenship
      user_address
      fideId
      ltsU10Id
      duprId
      teU12Id
      otherPoints
      pdlId
      ipinId
      teId
      atpId
      wtaId
      bonusU14
      bonusU12
      bonusPoints
      bonusU16
      wprUserId
      wprPlayerId
      fivb
      itf_points
      user_national_id_2
      uciId
      fipPoints

      additionalUserRole
      plans {
        id
        plan
      }
      stripe_payments {
        productId
        status
      }
    }
  }
`;

export default USER_BY_ID;
